import { useAppDispatch } from "integrations/redux/hooks"
import { SupportedRegions } from "@nova/constants"
import { setGlobalNotificationContext } from "user/profile/slice"
import { GlobalNotificationStatus } from "@nova/component-global-notification"
import { setCopyingExportId } from "features/map/inspector-panel/slice"

let isCopyingLink = false

export const useCopyResourceLink = ({
    workspaceId,
    fireId,
    flightId,
    isDemo,
}: {
    workspaceId: string
    fireId: string
    flightId: string
    isDemo: boolean
}) => {
    const dispatch = useAppDispatch()

    return async (exportOptionId: string, resource: string, generate?: () => Promise<unknown>) => {
        if (isCopyingLink) return
        isCopyingLink = true
        dispatch(setCopyingExportId(exportOptionId))

        let linkFailed = false
        const buildLinkBlob = async () => {
            try {
                if (generate) await generate()
                const res = await fetch(
                    `/api/organization/${workspaceId}/project/${fireId}/chapter/asd/flight/${flightId}/createUrl?resource=${resource}&isDemo=${isDemo}`,
                    {
                        headers: {
                            region:
                                JSON.parse(sessionStorage.getItem("region") || "null") ||
                                SupportedRegions.Canada,
                        },
                    }
                )
                const data = await res.json()
                if (!data.url) throw new Error("Invalid response")
                return new Blob([data.url], { type: "text/plain" })
            } catch (err) {
                linkFailed = true
                throw err
            }
        }

        try {
            await navigator.clipboard.write([new ClipboardItem({ "text/plain": buildLinkBlob() })])
            dispatch(
                setGlobalNotificationContext({
                    message: "Copied link to clipboard.",
                    status: GlobalNotificationStatus.success,
                    timeoutInMs: 5000,
                })
            )
        } catch (err) {
            console.error(err)
            dispatch(
                setGlobalNotificationContext({
                    message: linkFailed
                        ? "Failed to create link. Please try again later."
                        : "Failed to copy link to clipboard. Try again, staying on this tab.",
                    status: GlobalNotificationStatus.error,
                    timeoutInMs: 5000,
                })
            )
        } finally {
            isCopyingLink = false
            dispatch(setCopyingExportId(undefined))
        }
    }
}
